import BrowserRouter from '../libs/BrowserRouter';
import router from './router';

let browserRouter = global.browserRouter = new BrowserRouter(router);

export default browserRouter;
